import React from 'react';

const LoadJavascript = (props) => {
  const { loadSpinnerCreateJavascript } = props;

  return (
      <div
        style={loadSpinnerCreateJavascript === false ? { display: 'none' } : null}
        id="cover-spin2"
      >
        <div
          style={{
            position: 'absolute',
            top: '35%',
            fontSize: '1.5vw',
            justifyContent: 'center',
            display: 'flex',
            width: '100%'
          }}
        >
          {' '}
          <span style={{ color: '#0c4d82' }}>
            Please wait while creating javascript functions..{' '}
          </span>
        </div>
      </div>
  );
};

export default LoadJavascript;
